module.exports = __webpack_public_path__ + "static/scale-model-of-statesman-bat-observation-center-in-austin-texas-08a9af351e97c13bd05e32d4ea1c0f57.png";